import { httpClient } from './clients';
import { URL_CONFIG } from './endpoints';

export interface RedirectResponse {
  redirect: boolean;
  newUrl?: string;
}

export const urlConfigApi = {
  findRedirect: async (url: string): Promise<RedirectResponse> => {
    const response = await httpClient.post(URL_CONFIG.FIND_REDIRECT, { url });
    return response.data;
  },
};
